import type { AllEntities } from 'c-sdk';
import { generatePath } from 'react-router-dom';
import type { EntityListRow } from '../types';

type RouteTemplate = string | ((id: number) => string);

function generateRows({
    ids,
    baseEntityName,
    routeTemplate,
    onClick,
}: {
    ids: number[];
    baseEntityName: keyof AllEntities;
    routeTemplate?: RouteTemplate;
    onClick?: (id: number, event: React.MouseEvent<HTMLTableRowElement>) => void;
}): EntityListRow[] {
    return ids.map((id, index) => ({
        id,
        index,
        baseEntityName,
        onClick: onClick ? event => onClick(id, event) : null,
        link: routeTemplate
            ? typeof routeTemplate === 'string'
                ? generatePath(routeTemplate, { id })
                : routeTemplate(id)
            : undefined,
    }));
}

export default generateRows;
